import { render, staticRenderFns } from "./posMemory.vue?vue&type=template&id=085a930f&scoped=true&"
import script from "./posMemory.vue?vue&type=script&lang=js&"
export * from "./posMemory.vue?vue&type=script&lang=js&"
import style0 from "./posMemory.vue?vue&type=style&index=0&id=085a930f&prod&scoped=true&lang=css&"
import style1 from "./posMemory.vue?vue&type=style&index=1&id=085a930f&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "085a930f",
  null
  
)

export default component.exports